'use client';

import { useState, useCallback } from 'react';
import { NavDropdown, NavDropdownItem } from '@/components/nav/NavDropdown';

interface OriginSibling {
  slug: string;
  originCode: string;
  originFlag: string;
  originName: string;
}

interface CrossCalendarOriginSelectorProps {
  currentOriginCode: string;
  currentOriginFlag: string;
  currentOriginName: string;
  siblings: OriginSibling[];
}

export function CrossCalendarOriginSelector({
  currentOriginCode,
  currentOriginFlag,
  currentOriginName,
  siblings,
}: CrossCalendarOriginSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen(o => !o), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <NavDropdown
      trigger={<><span>{currentOriginFlag}</span> <span>{currentOriginName}</span></>}
      isOpen={isOpen}
      onToggle={toggle}
      onClose={close}
      label="Select origin country"
      wide
    >
      {siblings.map(s => (
        <NavDropdownItem
          key={s.originCode}
          icon={s.originFlag}
          label={s.originName}
          isActive={s.originCode === currentOriginCode}
          href={`/${s.slug}`}
          onClick={close}
        />
      ))}
    </NavDropdown>
  );
}
